import { gql } from "@apollo/client";
import ChangesFragments from "./ChangesFrament";

const RaceDetailsFragments = {
  entry: gql`
    fragment RaceDetails on Race {
      raceNumber: number
      trackCode
      description
      distance
      purse
      isGreyhound
      numRunners
      numWagerableRunners
      claimingPrice
      surface {
        name
        shortName
        defaultCondition
      }
      type {
        name
        code
        shortName
      }
      raceClass {
        name
        shortName
      }
      talentPicks {
        id
      }
      timeform {
        analystVerdict
      }
      ...Changes
    }
    ${ChangesFragments.entry}
  `
};

export default RaceDetailsFragments;
